module.exports = __webpack_public_path__ + "img/asset_ETH.0aeea19f.svg";